import { isEmpty } from 'lodash';

import { IFormProps } from '@/interface';
/**
 * 过滤form配置
 * @param filter
 * @param filterValue
 * @returns
 */
export const filterForm = (
  filter?: IFormProps['filter'],
  filterValue?: {
    [key: string]: unknown;
  },
) => {
  if (filter && !isEmpty(filter)) {
    return filter.every((mp) => {
      if (
        mp.value?.includes(filterValue?.[mp.key as keyof typeof filterValue])
      ) {
        return true;
      }
      return false;
    });
  }
  return true;
};
